module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Wine-5eb21fac875d58c743d6e3c8f2d904ba.svg";